import React, { useCallback } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiCol } from "../../../_uiComponents/grid-container/GridContainer";
import { UiInput, UiInputLink } from "../../../_uiComponents/form/UiInput";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { UiButton, UiButtonPrimary } from "../../../_uiComponents/form/UiButton";
import { loginAuthRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage"

const validateSchema = () =>
    yup.object().shape({
        // currentPassword: yup.string().required("Current Password is required."),
        // newPassword: yup.string().required("New Password is required."),
        // confirmedNewPassword: yup.string().required("Confirm Password is required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function ChangeAddress(props) {

    const submit = async (values) => {
        const payload = {
            no:values?.streetNo ? values?.streetNo : "" ,
            addressLine1:values.addressLine1 ? values.addressLine1 : '',
            addressLine2:values.addressLine2 ? values.addressLine2 : '',
            town:values.city ? values.city : '',
            postalCode:values.postalCode ? values.postalCode : '',
        }
        props.changeHomeAddress(payload);

    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            initialValues={{
                streetNo:props?.userDetails?.participantHomeAddress?.no,
                addressLine1:props?.userDetails?.participantHomeAddress?.addressLine1,
                addressLine2:props?.userDetails?.participantHomeAddress?.addressLine2,
                city:props?.userDetails?.participantHomeAddress?.town,
                postalCode:props?.userDetails?.participantHomeAddress?.postalCode,
            }}
            render={({ handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiInlineSuccessMessage/>
                    <UiCol lg="12">
                        <UiInput type="text" name="streetNo" placeholder="Street No"/>
                    </UiCol>
                    <UiCol lg="12">
                        <UiInput type="text" name="addressLine1" placeholder="Address Line 1"/>
                    </UiCol>
                    <UiCol lg="12">
                        <UiInput type="text" name="addressLine2" placeholder="Address Line 2"/>                                                      
                    </UiCol>
                    <UiCol lg="12">
                        <UiInput type="text" name="city" placeholder="City"/>
                    </UiCol>
                    <UiCol lg="12">
                        <UiInput type="text" name="postalCode" placeholder="Postal Code"/>
                    </UiCol>

                
                    <UiCol lg="12">
                        <div className="sb-prof-pwd-update-btn">
                            <UiButtonPrimary
                                btnName={"Save"}
                                onClick={handleSubmit}
                            />
                            <UiButtonPrimary
                                btnName={"Cancel"}
                                onClick={() => {props.handleCancel(false)}}
                            />
                        </div>
                    </UiCol>
                </form>
            )}
        />
    );
}
